import { IApplicationState } from '../types/redux';

export const selectRealtorInfo = (state: IApplicationState) => state.realtorInfo;
